import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-receipt" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "company-details" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "PHARMATEC PTE LIMITED", -1)
const _hoisted_5 = { class: "company-detail" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "P.O.Box ", -1)
const _hoisted_7 = { class: "company-detail" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Ph: ", -1)
const _hoisted_9 = { class: "company-detail" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Fax: ", -1)
const _hoisted_11 = { class: "company-detail" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Email: ", -1)
const _hoisted_13 = { class: "order-details" }
const _hoisted_14 = { class: "order-detail" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Requested Date: ", -1)
const _hoisted_16 = { class: "order-detail" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "To: ", -1)
const _hoisted_18 = { border: "1" }
const _hoisted_19 = ["textContent"]
const _hoisted_20 = ["textContent"]

type Header = {
    text: string,
    value: string
}

type Props = {
    company: string,
    companyAddress: string,
    companyMobile: string,
    companyPhone: string,
    companyEmail: string,

    supplier: string,
    orderNo: string,
    requestedDate: string,

    headers: Header[],
    items: any[],
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetails',
  props: {
    company: {},
    companyAddress: {},
    companyMobile: {},
    companyPhone: {},
    companyEmail: {},
    supplier: {},
    orderNo: {},
    requestedDate: {},
    headers: {},
    items: {}
  },
  setup(__props: any) {


const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.companyAddress), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.companyMobile), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_ctx.companyPhone), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(_toDisplayString(_ctx.companyEmail), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h1", null, "Purchase Order #" + _toDisplayString(_ctx.orderNo), 1),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_ctx.requestedDate), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createTextVNode(_toDisplayString(_ctx.supplier), 1)
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_18, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
          return (_openBlock(), _createElementBlock("th", {
            textContent: _toDisplayString(header.text)
          }, null, 8, _hoisted_19))
        }), 256))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
            return (_openBlock(), _createElementBlock("td", {
              textContent: _toDisplayString(item[header.value])
            }, null, 8, _hoisted_20))
          }), 256))
        ]))
      }), 256))
    ])
  ]))
}
}

})